import {NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {IonicModule} from "@ionic/angular";
import {CommonPipesModule} from "../../pipes/common/pipes.module";
import {AddressSearchComponent} from "./address-search/address-search.component";
import {AvatarComponent} from "./avatar/avatar.component";
import {CarComponent} from "./car/car.component";
import {InputBoolComponent} from "./input-bool/input-bool.component";
import {InputDateComponent} from "./input-date/input-date.component";
import {InputSelectComponent} from "./input-select/input-select.component";
import {ItemComponent} from "./item/item.component";
import {MapPopupCarComponent} from "./map-popup-car/map-popup-car.component";
import {MapPopupComponent} from "./map-popup/map-popup.component";
import {MapPopupPoiComponent} from "./map-popup-poi/map-popup-poi.component";
import {OutputComponent} from "./output/output.component";
import {PageTitleComponent} from "./page-title/page-title.component";
import {PoiComponent} from "./poi/poi.component";
import {SelectComponent} from "./select/select.component";
import {SelectChipComponent} from "./select-chip/select-chip.component";
import {SidebarComponent} from "./sidebar/sidebar.component";
import {PopoverMapSettingsComponent} from "./popover-map-settings/popover-map-settings.component";
import {PopoverFlagComponent} from "./popover-flag/popover-flag.component";
import {PopoverMapTypeComponent} from "./popover-map-type/popover-map-type.component";
import {SelectPoiComponent} from "./select-poi/select-poi.component";
import {PopoverSelectCarComponent} from "./popover-select-car/popover-select-car.component";
import {VehicleSelectComponent} from "./vehicle-select/vehicle-select.component";
import {PopoverSelectPoiComponent} from "./popover-select-poi/popover-select-poi.component";
import {TranslateModule} from "@ngx-translate/core";
import {SelectDialCodeComponent} from "./select-dial-code/select-dial-code.component";
import {PopoverSelectComponent} from "./popover-select/popover-select.component";
import {StepsComponent} from "./steps/steps.component";
import {TopbarComponent} from "./topbar/topbar.component";
import {DemoTourComponent} from "./demo-tour/demo-tour.component";
import {DemoChatComponent} from "./demo-chat/demo-chat.component";
import {CommonComponentsModule} from "../common/common-components.module";
import {UserPersonalDataComponent} from "src/app/components/desktop/user-personal-data/user-personal-data.component";
import {ShippingDataComponent} from "src/app/components/desktop/shipping-data/shipping-data.component";
import {ReactiveFormsModule} from "@angular/forms";
import {PopoverSelectMultipleCarComponent} from "src/app/components/desktop/popover-select-multiple-car/popover-select-multiple-car.component";
import {
  InputDeviceComponent
} from "./input-device/input-device.component";
import {ReportSettingsPage} from "src/app/pages/desktop/common/report-settings/report-settings.page";
import {PopoverListParticipantComponent} from "src/app/components/desktop/popover-list-participant/popover-list-participant.component";
import {
  CondiviosionePosizioneAddComponent
} from "./condiviosione-posizione-add/condiviosione-posizione-add.component";
import {
  OwlDateTimeModule
} from "@danielmoncada/angular-datetime-picker";

@NgModule({
  declarations: [
    // component
    AddressSearchComponent,
    AvatarComponent,
    CarComponent,
    InputBoolComponent,
    InputDateComponent,
    InputSelectComponent,
    ItemComponent,
    MapPopupCarComponent,
    MapPopupComponent,
    MapPopupPoiComponent,
    OutputComponent,
    PageTitleComponent,
    PoiComponent,
    SelectComponent,
    SelectChipComponent,
    SidebarComponent,
    StepsComponent,
    VehicleSelectComponent,
    // popover
    PopoverFlagComponent,
    PopoverMapSettingsComponent,
    PopoverMapTypeComponent,
    PopoverSelectComponent,
    PopoverSelectCarComponent,
    PopoverSelectPoiComponent,
    SelectPoiComponent,
    SelectDialCodeComponent,
    TopbarComponent,
    DemoTourComponent,
    DemoChatComponent,
    UserPersonalDataComponent,
    ShippingDataComponent,
    PopoverSelectMultipleCarComponent,
    PopoverListParticipantComponent,
    InputDeviceComponent,
    ReportSettingsPage,
    CondiviosionePosizioneAddComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    CommonPipesModule,
    CommonComponentsModule,
    ReactiveFormsModule,
    OwlDateTimeModule
  ],
  exports: [
    // component
    AddressSearchComponent,
    AvatarComponent,
    CarComponent,
    InputBoolComponent,
    InputDateComponent,
    InputSelectComponent,
    ItemComponent,
    MapPopupCarComponent,
    MapPopupComponent,
    MapPopupPoiComponent,
    OutputComponent,
    PageTitleComponent,
    PoiComponent,
    SelectComponent,
    SelectChipComponent,
    SidebarComponent,
    StepsComponent,
    VehicleSelectComponent,
    TopbarComponent,
    DemoTourComponent,
    DemoChatComponent,
    UserPersonalDataComponent,
    ShippingDataComponent,
    PopoverSelectMultipleCarComponent,
    PopoverListParticipantComponent,
    InputDeviceComponent,
    ReportSettingsPage,
    CondiviosionePosizioneAddComponent
  ],
})

export class DesktopComponentsModule {}
